import { combineReducers } from '@reduxjs/toolkit';
import auth from './authReducer';
import memberships from './membershipReducer';
import usersAdmin from './usersAdminReducer';
import invites from './invitesReducer';
import roles from './rolesReducer';
import apiKeys from './apiKeysReducer';

export default combineReducers({ auth, memberships, usersAdmin, invites, roles, apiKeys });
